/* eslint-disable @typescript-eslint/no-explicit-any */
const getStoreText = ({
  copies,
  storeName,
  enabledOpModelSuffix,
}: {
  copies: any
  storeName: string
  enabledOpModelSuffix: boolean
}) => {
  if (enabledOpModelSuffix) {
    const { opModel } = copies.header?.subheader || {}
    return `${storeName || ''} ${opModel?.suffixPickAndCollect || ''}`
  }
  return storeName || ''
}

export default getStoreText
